import { render } from "./QuestionView.vue?vue&type=template&id=30a40742&ts=true"
import script from "./QuestionView.vue?vue&type=script&lang=ts"
export * from "./QuestionView.vue?vue&type=script&lang=ts"

import "./QuestionView.vue?vue&type=style&index=0&id=30a40742&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__